<template>
    <div class="contentRightMenu">
        <div class="gl_title_bar marginBottom10">
            <div class="gl_tb_left">
                <span class="normaltitle">学术订阅</span>
                <a href="javascript:;"
                   :class="{gl_pad_btn_active:tagIndex=='tagSubscribeMy'}"
                   @click="tagContent('tagSubscribeMy')"
                   class="gl_pad_btn  marginLeft10">我的订阅</a>
                <a href="javascript:;"
                   :class="{gl_pad_btn_active:tagIndex=='tagSubscribeContent'}"
                   @click="tagContent('tagSubscribeContent')"
                   class="gl_pad_btn  marginLeft10">订阅内容</a>
                <a href="javascript:;"
                   :class="{gl_pad_btn_active:tagIndex=='tagSubscribeRecord'}"
                   @click="tagContent('tagSubscribeRecord')"
                   class="gl_pad_btn  marginLeft10">推送记录</a>
            </div>
        </div>
        <component :is="tagIndex"></component>
    </div>
</template>

<script>
    import tagSubscribeMy from "./tagSubscribeMy"
    import tagSubscribeContent from "./tagSubscribeContent"
    import tagSubscribeRecord from "./tagSubscribeRecord"
    export default {
        name: "userSubscribeMenu",
        data(){
            return {
                tagIndex:"tagSubscribeMy",
            }
        },
        components:{
            tagSubscribeMy,
            tagSubscribeContent,
            tagSubscribeRecord
        },
        methods:{
            tagContent(index){
                this.tagIndex=index
            }
        }
    }
</script>

<style scoped>
</style>
